// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-71fe2192] .page-pageination {\n  text-align: right;\n  padding: 10px 0;\n}\n[data-v-71fe2192] .page-pageination .el-input {\n  display: inline-block !important;\n}\n", ""]);
// Exports
module.exports = exports;
